import { SxProps } from "@mui/system";
import { getInputStyles } from "../../../theme/styleHelpers";
import { ThemeV2 } from "../../../util/types";

export const inputStyle = (
  theme: ThemeV2,
  isLandScapeMode: boolean,
  hasInputAdornment = false,
): SxProps => ({
  height: "100%",
  width: "100%",
  ...getInputStyles(theme),
  borderRadius: `${theme.tokens.shape.radius.md}px`,
  border: "none",
  "& textarea": {
    color: isLandScapeMode ? theme.tokens.color.action.primary : null,
    fontSize: theme.tokens.typography.size,
  },
  "& .MuiOutlinedInput-root": {
    height: hasInputAdornment && !isLandScapeMode ? "100%" : undefined,
    padding:
      isLandScapeMode && hasInputAdornment
        ? 0
        : `${theme.tokens.spacing["1"]}px ${theme.tokens.spacing["1"]}px ${theme.tokens.spacing["1"]}px ${theme.tokens.spacing["2"]}px`,
    minHeight:
      isLandScapeMode && hasInputAdornment
        ? { md: "93px", xs: "63px" }
        : undefined,
    alignItems: isLandScapeMode && hasInputAdornment ? "stretch" : undefined,
    "& textarea": {
      alignSelf: "center",
      paddingInline:
        isLandScapeMode && hasInputAdornment
          ? `${theme.tokens.spacing["6"]}px`
          : undefined,
    },
    "& .MuiInputAdornment-root": {
      alignSelf: "stretch",
      height: "auto",
      maxHeight: "none",
      minWidth: isLandScapeMode ? { md: "64px", xs: "40px" } : undefined,
      maxWidth: "50%",
      flex: "0 1 auto",
      justifyContent: "center",
      boxSizing: "border-box",
      overflow: "hidden",
      color: theme.tokens.color.action.primary,
      fontWeight: theme.tokens.typography.weight.medium,
      backgroundColor: `color-mix(in srgb, ${theme.tokens.color.action.primary} 10%, ${theme.tokens.color.surface.card})`,
      marginBlock: isLandScapeMode ? 0 : `-${theme.tokens.spacing["1"]}px`,
      paddingBlock: isLandScapeMode ? 0 : `${theme.tokens.spacing["1"]}px`,
      "& .MuiTypography-root": {
        color: theme.tokens.color.action.primary,
        fontSize: theme.tokens.typography.size,
        fontWeight: theme.tokens.typography.weight.medium,
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        textAlign: "center",
      },
    },
    "& .MuiInputAdornment-positionStart": {
      borderInlineEnd: `1px solid ${theme.tokens.color.action.primary}`,
      marginInlineStart: isLandScapeMode
        ? 0
        : `-${theme.tokens.spacing["2"]}px`,
      marginInlineEnd: 0,
      paddingInlineStart: isLandScapeMode
        ? 0
        : `${theme.tokens.spacing["4"]}px`,
      paddingInlineEnd: isLandScapeMode ? 0 : `${theme.tokens.spacing["4"]}px`,
    },
    "& .MuiInputAdornment-positionEnd": {
      borderInlineStart: `1px solid ${theme.tokens.color.action.primary}`,
      marginInlineStart: 0,
      marginInlineEnd: isLandScapeMode ? 0 : `-${theme.tokens.spacing["1"]}px`,
      paddingInlineStart: isLandScapeMode
        ? 0
        : `${theme.tokens.spacing["4"]}px`,
      paddingInlineEnd: isLandScapeMode ? 0 : `${theme.tokens.spacing["4"]}px`,
    },
    "& fieldset": {
      borderColor: "transparent", // Remove border color when not focused
    },
    "&:hover fieldset": {
      borderColor: "transparent", // Remove border color on hover
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent", // Remove border color when focused
    },
  },
});
